import { useState, useCallback } from 'react';
import { journalEntriesApi } from '../services/api/endpoints/journalEntries';
import type { JournalEntry } from '../types/accounting';

export function useJournalReversal() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const reverseEntry = useCallback(async (
    id: string,
    data?: { reversalDate?: string; description?: string }
  ): Promise<JournalEntry | null> => {
    try {
      setLoading(true);
      setError(null);

      const response = await journalEntriesApi.reverse(id, data);
      if (response && 'data' in response) {
        const reversalEntry = (response.data as any)?.data || response.data;
        return reversalEntry as JournalEntry;
      }
      return null;
    } catch (err: any) {
      const message = err.message || 'Erreur lors de l\'extourne';
      setError(message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    reverseEntry,
  };
}
